import {
  getArticlesList,
  getArticle,
  updateArticle,
  getArticlesTagList,
} from '../api/articles';

const initialState = {
  articles: null,
  selectedArticle: null,
  tagList: null,
};

const ARTICLES = 'ARTICLES';
const ARTICLE_SELECTED = 'ARTICLE_SELECTED';
const TAGLIST = 'TAGLIST';

const setArticles = (articles) => ({type: ARTICLES, payload: articles});
const setSelectedArticle = (article) => ({
  type: ARTICLE_SELECTED,
  payload: article,
});
const setTagList = (tagList) => ({type: TAGLIST, payload: tagList});

export const fetchArticles = (token) => {
  return async (dispatch) => {
    const res = await getArticlesList(token);
    if (res !== 'error') {
      return dispatch(setArticles(res.data));
    }
  };
};

export const removeArticles = () => {
  return (dispatch) => {
    return dispatch(setArticles(null));
  };
};

export const fetchSelectedArticle = (id, token) => {
  return async (dispatch) => {
    const res = await getArticle(id, token);
    if (res !== 'error') {
      return dispatch(setSelectedArticle(res.data));
    }
  };
};

export const fetchUpdateSelectedArticle = (id, token, article) => {
  return async (dispatch) => {
    const res = await updateArticle(id, token, article);
    if (res !== 'error') {
      return dispatch(setSelectedArticle(res.data));
    }
  };
};

export const resetSelectedArticle = () => {
  return (dispatch) => {
    return dispatch(setSelectedArticle(null));
  };
};

export const fetchArticleTagList = (token) => {
  return async (dispatch) => {
    const res = await getArticlesTagList(token);
    if (res !== 'error') {
      return dispatch(setTagList(res.data));
    }
  };
};

const articlesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ARTICLES:
      return {...state, articles: action.payload};
    case ARTICLE_SELECTED:
      return {...state, selectedArticle: action.payload};
    case TAGLIST:
      return {...state, tagList: action.payload};
    default:
      return {...state};
  }
};

export default articlesReducer;
